import { isAxiosError } from "./isAxiosError";
import { redactAxiosError } from "./redactAxiosError";

// Since a catch block's first parameter is unknown, this util function will allow us to use remiLogger.captureError()
// and not need to created typed errors for the edge case that an error that is not an Error is thrown
export function getError(value: unknown): Error {
  if (value instanceof Error) {
    if (isAxiosError(value)) {
      redactAxiosError(value);
    }
    return value;
  }

  let message: string;
  try {
    if (typeof value === "object" && value !== null) {
      message = JSON.stringify(value, null, 2);
    } else {
      message = String(value);
    }
  } catch {
    // Handle circular references or other JSON.stringify errors
    message = `[Unserializable object: ${String(value)}]`;
  }

  // oxlint-disable-next-line remi/no-vanilla-error -- ignore exhaustive deps check
  return new Error(message);
}
